// @todo: Migrate to 'RadioGroup' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Radio} from '@wandb/weave/components';
import React, {useMemo} from 'react';

import {Analytics} from '../../../../services/analytics';
import {usePartMaybe} from '../../../../state/views/hooks';
import {
  ColorPaletteOption,
  getColorPaletteOptionTitle,
  getColorPaletteSpectrumOrder,
} from '../../../../util/colors';
import {useMaybeWorkspaceRefsContext} from '../../../Workspace/WorkspaceRefsContext';
import {SettingLabel} from '../components/SettingLabel';
import {RunColorOptions} from '../types';
import {useMaybeWorkspaceSettingsContext} from '../WorkspaceSettingsContextProvider';
import {ColorPalettePreview} from './ColorPalettePreview';

const OPTIONS = [
  ColorPaletteOption.DEFAULT,
  ColorPaletteOption.COMMON_DEUTERONOMALY,
  ColorPaletteOption.OTHER_COLOR_BLIND_PALETTE,
];

export const useWorkspaceSettingsColorPalette = () => {
  const workspaceRefs = useMaybeWorkspaceRefsContext();
  const workspaceSettings = usePartMaybe(workspaceRefs?.workspaceSettingsRef);
  // The color palette only applies when we're showing the original run colors
  if (
    workspaceSettings != null &&
    (workspaceSettings?.semanticLegendRunColorOptions == null ||
      workspaceSettings?.semanticLegendRunColorOptions ===
        RunColorOptions.OriginalProjectColors)
  ) {
    const colorPaletteOption = workspaceSettings?.colorPaletteOption;
    if (colorPaletteOption == null || !OPTIONS.includes(colorPaletteOption)) {
      return ColorPaletteOption.DEFAULT;
    }
    return colorPaletteOption;
  }
  return ColorPaletteOption.DEFAULT;
};

export const ColorPalette = () => {
  const workspaceSettings = useMaybeWorkspaceSettingsContext();
  const colorPaletteOption = useWorkspaceSettingsColorPalette();
  const colorPaletteColors = useMemo(
    () => getColorPaletteSpectrumOrder(colorPaletteOption),
    [colorPaletteOption]
  );

  return (
    <div className="flex flex-col">
      <SettingLabel className="w-fit" text="Color palette" />
      <Radio.Root
        aria-label="Color palette"
        name="color-palette"
        onValueChange={(value: string) => {
          const option = OPTIONS.find(option => String(option) === value);
          Analytics.track('Color palette changed', {newValue: option});
          workspaceSettings?.updateColorPaletteOption(option);
        }}
        value={String(colorPaletteOption)}>
        {OPTIONS.map(option => (
          <div key={option} className="flex items-center justify-start">
            <Radio.Item id={String(option)} value={String(option)}>
              <Radio.Indicator />
            </Radio.Item>
            <label htmlFor={String(option)}>
              <span className="mx-8">{getColorPaletteOptionTitle(option)}</span>
            </label>
          </div>
        ))}
      </Radio.Root>
      <ColorPalettePreview
        colors={colorPaletteColors}
        borderClassName="mt-16"
      />
    </div>
  );
};
